import { useSelector } from 'react-redux'
import { useMailboxAllTicketsCount } from 'ducks/searches/hooks'
import { selectCurrentMailboxId } from 'selectors/mailboxes'
import { selectHasCurrentTicketSearchLoaded } from 'selectors/search/base'

import React from 'react'
import UpdateAppBanner from 'components/Banners/UpdateApp'
import Switcher from './Switcher'
import styles from '../styles.less'

const MainCell = ({ isUpdateAvailable, ...rest }) => {
  const { ticketId } = rest
  const mailboxId = useSelector(state => selectCurrentMailboxId(state))
  const allTicketsCount = useMailboxAllTicketsCount(mailboxId)
  const hasLoaded = useSelector(state =>
    selectHasCurrentTicketSearchLoaded(state)
  )
  const showTestMessageButton = hasLoaded && allTicketsCount <= 0 && !ticketId

  return (
    <div className={styles.mainCell}>
      {isUpdateAvailable && <UpdateAppBanner />}
      <Switcher {...rest} showTestMessageButton={showTestMessageButton} />
    </div>
  )
}

export default MainCell
